module.exports = __webpack_public_path__ + "img/glow_pack.5e73d96e.png";